export const PERMS = {
    READ: 'report_customer_turnovers.read',
    UPDATE: 'report_customer_turnovers.update',
    DELETE: 'report_customer_turnovers.delete',
    CREATE: 'report_customer_turnovers.create',
}
